/* eslint-disable @typescript-eslint/no-explicit-any */
import { CategoryModel, ProductModel, TypeModel } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextValidator } from "react-material-ui-form-validator";
import {
  Autocomplete,
  Checkbox,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
} from "@mui/material";
import {
  deleteImagesFromProductVariants,
  handleChangeAutocomplete,
  onChangeTextField,
} from "../../Utils/Utils";
import { useContext, useEffect, useState } from "react";
import AddAndShowImages from "../GenericComponents/AddAndShowImages";
import { Add } from "@mui/icons-material";
import Type from "../ProductSettings/Types/Type";
import { postData } from "../../Services/postData";
import { urlEnum } from "../../Utils/UrlEnum";
import { CacheWebsocketContext } from "../../Contexts/WebsocketContext";
import useCustomMemo from "../GenericComponents/useCustomMemo";
import Category from "../ProductSettings/Categories/Category";

type ProductProps = {
  product: ProductModel;
  arraysOfString: any;
  handleChangeArraysOfString: (arraysOfString: any) => void;
  handleChangeProduct: (product: ProductModel) => void;
};

export default function Product(props: ProductProps) {
  const {
    product,
    handleChangeProduct,
    arraysOfString,
    handleChangeArraysOfString,
  } = props;
  const websocketContext = useContext(CacheWebsocketContext);
  const cache = useCustomMemo();
  const types = cache.types || [];
  const categories = cache.categories || [];
  const [images, setImages] = useState<any>([]);
  const [files, setFiles] = useState<any>([]);
  const [openType, setOpenType] = useState(false);
  const [openCategory, setOpenCategory] = useState(false);

  /**
   *
   */
  useEffect(() => {
    if (product.images) setImages(product.images);
    else setImages([]);
  }, [product.images]);

  /////////////////////////// ADD ITEM BUTTON FOR AUTOCOMPLETE ///////////////////////////
  function AddButtonForAutocomplete({ children, fieldName, ...other }: any) {
    return (
      <Paper {...other}>
        <div style={{ position: "absolute", right: -30, top: -32 }}>
          <IconButton
            onMouseDown={(e) => {
              e.preventDefault();
              if (fieldName === "type") setOpenType(true);
              else if (fieldName === "category") setOpenCategory(true);
            }}
            style={{
              background: "#18cc9c",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              padding: 13,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <Add style={{ verticalAlign: "middle" }} />
          </IconButton>
        </div>
        {children}
      </Paper>
    );
  }
  /////////////////////////// END ADD ITEM BUTTON FOR AUTOCOMPLETE ///////////////////////////

  /////////////////////////// ADD TYPE AND CATEGORY ///////////////////////////
  /**
   *
   * @param type
   */
  function addType(type: TypeModel | null) {
    postData(urlEnum.types, type)
      .then((res: any) => {
        if (res) {
          websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
          setOpenType(false);
        }
      })
      .catch((err) => {
        setOpenType(false);
      });
  }

  /**
   *
   * @param category
   */
  function addCategory(category: CategoryModel | null) {
    postData(urlEnum.categories, category)
      .then((res: any) => {
        if (res) {
          websocketContext.setShouldUpdate(!websocketContext.shouldUpdate);
          setOpenCategory(false);
        }
      })
      .catch((err) => {
        setOpenCategory(false);
      });
  }

  /////////////////////////// END ADD TYPE AND CATEGORY ///////////////////////////

  /////////////////////////// ADD/UPDATE IMAGES ///////////////////////////
  /**
   *
   */
  function handleDeleteImages(newImageList: any, newFileList: any) {
    setImages(newImageList);
    setFiles(newFileList);
    const newProduct = Object.assign({}, product);
    newProduct.images = newImageList;
    newProduct.files = newFileList;
    newProduct.variants = deleteImagesFromProductVariants(
      newImageList,
      product.variants
    );
    handleChangeProduct(newProduct);
  }

  /**
   *
   * @param files
   */
  function handleChangeFiles(newFileList: any) {
    const allFiles = [...files, ...newFileList];
    setFiles(allFiles);
    const newProduct = Object.assign({}, product);
    newProduct.files = allFiles;
    handleChangeProduct(newProduct);
  }

  /**
   *
   * @param images
   */
  function displayDropzoneImages(newImageList: any) {
    setImages(newImageList);
    const newProduct = Object.assign({}, product);
    newProduct.images = newImageList;
    handleChangeProduct(newProduct);
  }

  /////////////////////////// END ADD/UPDATE IMAGES ///////////////////////////

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ marginTop: 20, padding: "0px 10px" }}
        justifyContent="space-between"
      >
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <TextValidator
            size="small"
            id="name"
            name="name"
            label={Vocabulary.name}
            fullWidth
            validators={["required"]}
            errorMessages={[Vocabulary.requiredField]}
            variant="outlined"
            value={product.name}
            onChange={(event: any) =>
              handleChangeProduct(onChangeTextField(event, product))
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <TextValidator
            size="small"
            id="description"
            name="description"
            label={Vocabulary.description}
            fullWidth
            variant="outlined"
            validators={["required"]}
            errorMessages={[Vocabulary.requiredField]}
            value={product.description || ""}
            onChange={(event: any) =>
              handleChangeProduct(onChangeTextField(event, product))
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <TextValidator
            size="small"
            id="code"
            name="code"
            label={Vocabulary.code}
            fullWidth
            validators={["required"]}
            errorMessages={[Vocabulary.requiredField]}
            variant="outlined"
            value={product.code}
            onChange={(event: any) =>
              handleChangeProduct(onChangeTextField(event, product))
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <TextValidator
            size="small"
            id="ean"
            name="ean"
            label={Vocabulary.ean}
            fullWidth
            variant="outlined"
            value={product.ean}
            onChange={(event: any) =>
              handleChangeProduct(onChangeTextField(event, product))
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <TextValidator
            size="small"
            id="manufacturer"
            name="manufacturer"
            label={Vocabulary.manufacturer}
            fullWidth
            variant="outlined"
            validators={["required"]}
            errorMessages={[Vocabulary.requiredField]}
            value={product.manufacturer}
            onChange={(event: any) =>
              handleChangeProduct(onChangeTextField(event, product))
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <Autocomplete
            size="small"
            id="type"
            freeSolo={true}
            options={types.map((type: TypeModel) => type.name)}
            value={product.type}
            getOptionLabel={(option: any) => option}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionDisabled={(option) => option === product.type}
            onChange={(event: any, value: any) =>
              handleChangeProduct(
                handleChangeAutocomplete(event, value, product, "type")
              )
            }
            PaperComponent={({ children, ...other }) =>
              AddButtonForAutocomplete({
                children,
                fieldName: "type",
                ...other,
              })
            }
            renderInput={(params: any) => (
              <TextValidator
                {...params}
                fullWidth
                label={Vocabulary.type}
                value={product.type}
                variant="outlined"
                validators={["required"]}
                errorMessages={[Vocabulary.requiredField]}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <Autocomplete
            size="small"
            id="category"
            freeSolo={true}
            options={categories.map((category: CategoryModel) => category.name)}
            value={product.category}
            getOptionLabel={(option: any) => option}
            isOptionEqualToValue={(option, value) => option === value}
            onChange={(event: any, value: any) =>
              handleChangeProduct(
                handleChangeAutocomplete(event, value, product, "category")
              )
            }
            PaperComponent={({ children, ...other }) =>
              AddButtonForAutocomplete({
                children,
                fieldName: "category",
                ...other,
              })
            }
            renderInput={(params: any) => (
              <TextField
                {...params}
                fullWidth
                label={Vocabulary.category}
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <Autocomplete
            size="small"
            id="tags"
            multiple
            freeSolo={true}
            options={arraysOfString.tags}
            value={product.tags || []}
            getOptionLabel={(option: any) => option}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionDisabled={(option) =>
              !!product.tags.find((element: any) => element === option)
            }
            onChange={(event: any, value: any) => {
              handleChangeProduct(
                handleChangeAutocomplete(event, value, product, "tags")
              );
              const tags = new Set([...arraysOfString.tags, ...value]);
              handleChangeArraysOfString({
                ...arraysOfString,
                tags: Array.from(tags),
              });
            }}
            renderInput={(params: any) => (
              <TextField
                {...params}
                fullWidth
                label={Vocabulary.tags}
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          <Checkbox
            checked={product.hasGuarantee}
            onChange={(event: any) =>
              handleChangeProduct({
                ...product,
                hasGuarantee: event.target.checked,
              })
            }
          />
          {Vocabulary.hasGuarantee}
        </Grid>
        <Grid item xs={12} sm={12} md={5.8} lg={5.8}>
          {product.hasGuarantee ? (
            <TextValidator
              size="small"
              type="number"
              id="guaranteePeriod"
              name="guaranteePeriod"
              label={Vocabulary.guaranteePeriod}
              fullWidth
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              variant="outlined"
              value={product.guaranteePeriod}
              onChange={(event: any) =>
                handleChangeProduct(onChangeTextField(event, product))
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {Vocabulary.month}/{Vocabulary.months}
                  </InputAdornment>
                ),
              }}
            />
          ) : null}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <AddAndShowImages
            images={images}
            files={files}
            displayDropzoneImages={displayDropzoneImages}
            handleDeleteImages={handleDeleteImages}
            handleChangeFiles={handleChangeFiles}
            maxFiles={10}
            isSmall={true}
          />
        </Grid>
      </Grid>
      {openType ? (
        <Type
          editType={null}
          open={openType}
          addOrUpdateType={(type: TypeModel | null) => addType(type)}
          onClose={() => setOpenType(false)}
        />
      ) : null}
      {openCategory ? (
        <Category
          editCategory={null}
          open={openCategory}
          addOrUpdateCategory={(category: CategoryModel | null) =>
            addCategory(category)
          }
          onClose={() => setOpenCategory(false)}
        />
      ) : null}
    </>
  );
}
